import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import UserStore from "../../store/UserStore";
import ReportsStore from "../../store/ReportsStore";
import { setCookie } from "../../utils/cookie";
import { getTaxPdfFileMeta } from "../../utils/functions";
import Modal from "../../components/Modal";
import AllErrorModalUGL from "../../components/ModalFamily/AllErrorModalUGL";
import {
  errorModalPadding,
  fileDownloadingMessage,
  noDataError,
  somethingWrongErrAll,
} from "../../utils/constants";

const DownloadPdf = () => {
  const userHydrated = UserStore.isHydrated;

  const [downloadFile, setDownloadFile] = useState({
    isFetching: true,
    isError: false,
    data: null,
  });

  useEffect(() => {
    if (UserStore.isHydrated) {
      // After hydration , get all the required parameters and trigger the API call ,
      // On Success of API call set the cookie and close the window
      // On failure set the error state to show the error modal
      // Then in allRoutes check for the cookie and download the file and clear the cookie

      const params = {
        memberCode: UserStore.selectedAccount?.accountCode,
        memberName: UserStore.selectedAccount?.accountName,
        FromDate: UserStore.taxPdfDownloadFromDate,
        ToDate: UserStore.taxPdfDownloadToDate,
        isPDF: 1,
      };

      const onSuccess = (res) => {
        const status = res.status;

        if (status === 204) {
          setDownloadFile({
            isFetching: false,
            isError: noDataError,
            data: null,
          });
        } else {
          const fileMeta = getTaxPdfFileMeta({
            data: res.data,
            account: UserStore.selectedAccount,
          });

          setCookie("url", JSON.stringify(fileMeta));

          setDownloadFile({
            data: JSON.stringify(fileMeta),
            isError: false,
            isFetching: false,
          });
          setTimeout(() => {
            window.close();
          }, 1100);
        }
        ReportsStore.setTaxDates("", "taxPdfDownloadFromDate");
        ReportsStore.setTaxDates("", "taxPdfDownloadToDate");
      };

      ReportsStore.downloadTaxReportPdfFile({
        params,
        onSuccess: onSuccess,
        onFail: (error) => {
          setDownloadFile({
            data: null,
            isError: somethingWrongErrAll,
            isFetching: false,
          });
          ReportsStore.setTaxDates("", "taxPdfDownloadFromDate");
          ReportsStore.setTaxDates("", "taxPdfDownloadToDate");
        },
      });
    }
  }, [userHydrated]);
  return (
    <div>
      {downloadFile.isFetching && (
        <div className="loading_screen taxloading">
          <p>{fileDownloadingMessage}</p>
          <img className="loading_gif" src={loaderGIF} alt="loading..." />
        </div>
      )}
      <Modal
        modalStyle={errorModalPadding}
        showCloseIcon={true}
        open={downloadFile.isError}
        onClose={() => {
          window.close();
        }}
      >
        <AllErrorModalUGL
          msg={downloadFile.isError}
          onConfirm={() => window.close()}
        />
      </Modal>
    </div>
  );
};

export default observer(DownloadPdf);
